import { useContext } from 'react';
import HeadContext from './context/HeadContext';

const usePageTitle = () => {
  return useContext(HeadContext);
};
export default usePageTitle;
